import { render, staticRenderFns } from "./ValueChart.vue?vue&type=template&id=3ca90826&scoped=true"
import script from "./ValueChart.vue?vue&type=script&lang=js"
export * from "./ValueChart.vue?vue&type=script&lang=js"
import style0 from "./ValueChart.vue?vue&type=style&index=0&id=3ca90826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca90826",
  null
  
)

export default component.exports